/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import Masks from '../../../../utils/masks';
import {
  DataGrid,
  Grid,
  Input,
  ControlePeriodosVigencia,
  ControleOrgaosCentralizados,
} from '../../../../components/index';
import {
  tipoEntidade,
  getObject,
  convenioComprev,
} from '../../../../utils/listsSelect';
import * as constantes from './../../../../utils/constants';

const DadosRegimeProprio = (props) => {
  const addTipoEntidadeLabel = (tipo) => {
    const obj = getObject(tipoEntidade, tipo);
    let valorlabel = null;
    if (obj) {
      valorlabel = obj.label;
    }
    return valorlabel;
  };

  const listaPeriodosIndexada = props.periodosVigencia.map((item, i) => {
    const itemIndexado = item;
    itemIndexado.index = i;
    if (itemIndexado.origemCadprev) {
      itemIndexado.processado = true;
    }
    return itemIndexado;
  });

  let periodosVigencia;
  if (props.periodosVigencia.length > 0) {
    periodosVigencia = (
      <ControlePeriodosVigencia
        periodosVigencia={listaPeriodosIndexada}
        // handleSearchPesquisaCadPrevButton={handleSearchCadPrevButton}
      />
    );
  }

  const listaOrgaosCentralizados = props.orgaosCentralizados.map((item, i) => {
    const itemIndexado = item;
    itemIndexado.index = i;
    return itemIndexado;
  });

  let orgaosCentralizados;
  if (props.orgaosCentralizados.length > 0) {
    orgaosCentralizados = (
      <ControleOrgaosCentralizados
        orgaosCentralizados={listaOrgaosCentralizados}
        buscaParticipanteRpps={props.buscaParticipanteRpps}
        // handleSuccessBuscaDadosParticipanteRpps={props.handleSuccessBuscaDadosParticipanteRpps}
        // handleErrorBusca={props.handleErrorBusca}
      />
    );
  }

  return (
    <React.Fragment>
      <DataGrid title="Dados do Ente Federativo" icon="ico-user-plus" >
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              disabled
              label="CNPJ do Ente Federativo"
              mask={Masks.cnpj}
              showMask
              value={props.estadoFormulario.regimeProprio.cnpjEf}
            />
          </Grid>
          {props.estadoFormulario.regimeProprio.inOrgaoUniao !== 1 ?
            <Grid cols="6 6 6 6">
              <Input
                disabled
                label="Nome do Ente Federativo"
                value={props.estadoFormulario.regimeProprio.nomeEf}
              />
            </Grid>
          :
            <Grid cols="8 8 8 8">
              <Input
                disabled
                label="Nome do Ente Federativo"
                value={props.estadoFormulario.regimeProprio.nomeEf}
              />
            </Grid>
          }
          {props.estadoFormulario.regimeProprio.inOrgaoUniao !== 1 ?
            <Grid cols="2 2 2 2">
              <Input
                disabled
                label="UF"
                value={props.estadoFormulario.regimeProprio.ufEf}
              />
            </Grid>
         : ''}
        </div>
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              disabled
              label="Tipo da Entidade"
              value={addTipoEntidadeLabel(props.estadoFormulario.regimeProprio.tipoRegimeProprio)}
              custom
              onChange={e => props.handleChange(e, 'tipoRegimeProprio')}
            />
          </Grid>
          <Grid cols="8 8 8 8">
            <Input
              disabled
              integer
              label="Código"
              value={props.estadoFormulario.regimeProprio.idParticipante}
            />
          </Grid>
        </div>
        <div className="row">
          <Grid cols="12 12 12 12">
            {props.estadoFormulario.regimeProprio.inOrgaoUniao === 1 ?
              <Input
                disabled
                label="Situação"
                value={props.estadoFormulario.situacao}
              />
            : ''}
          </Grid>
        </div>
        <div className="row">
          <Grid cols="4 4 4 4">
            {props.estadoFormulario.acao === 'novo' ?
              <Input
                number
                itemList={convenioComprev}
                label="Conveniado"
                onChange={e => props.handleChangeAptoConvenio(e, 'convenioComprev')}
                touched={props.estadoFormulario.touched}
                value={props.estadoFormulario.regimeProprio.convenioComprev}
                placeholder="Selecione a opção"
                custom
              />
            : ''}
            {props.estadoFormulario.acao === 'atualizar-rpps' && props.auth.checkPermission(['analisar-negocio-sprev']) ?
              <Input
                number
                itemList={convenioComprev}
                label="Conveniado"
                onChange={e => props.handleChangeAptoConvenio(e, 'convenioComprev')}
                touched={props.estadoFormulario.touched}
                value={props.estadoFormulario.regimeProprio.convenioComprev}
                placeholder="Selecione a opção"
                custom
              />
            : '' }
            {!props.auth.checkPermission(['analisar-negocio-sprev']) &&
              props.estadoFormulario.regimeProprio.convenioComprev === 1 ?
                <Input
                  id="conveniadoSim"
                  label=""
                  value="Conveniado"
                  disabled={(!props.auth.checkPermission(['analisar-negocio-sprev']))}
                  onChange={e => props.handleChange(e, 'convenioComprev')}
                />
            : ''}
          </Grid>
          {props.estadoFormulario.exibirDataConvenio ?
            <Grid cols="8 8 8 8">
              <Input
                disabled={(!props.auth.checkPermission(['analisar-negocio-sprev']))}
                label="Data do Convênio"
                onChange={e => props.handleChange(e, 'dataConvenio')}
                showMask
                value={props.estadoFormulario.regimeProprio.dataConvenio}
                mask={Masks.date}
                touched={props.estadoFormulario.touched}
                required
              />
            </Grid>
          : ''}
        </div>
        <div className="row">
          <Grid cols="12 12 12 12">
            <Input
              disabled={(!props.auth.checkPermission(['analisar-negocio-sprev']))}
              label="Email"
              maxLength="100"
              onChange={e => props.handleChange(e, 'enderecoEletronico')}
              value={props.estadoFormulario.regimeProprio.enderecoEletronico}
              touched={props.estadoFormulario.emailTouched}
            />
          </Grid>
        </div>
        <div className="row">
          <Grid cols="1 1 1 1">
            {props.estadoFormulario.regimeProprio.convenioComprev === 0 ?
              <Input
                disabled
                error={!props.estadoFormulario.validadeCampos.numeroBanco}
                maxLength="3"
                label="Banco"
                onChange={e => props.handleChange(e, 'numeroBanco')}
                onBlur={e => props.handleBlur(e, 'numeroBanco')}
                value={props.estadoFormulario.regimeProprio.numeroBanco}
                dadosBancarios
                touched={props.estadoFormulario.touched || props.estadoFormulario.bancoTouched}
              />
              :
              <Input
                disabled={(!props.auth.checkPermission(['analisar-negocio-sprev']))}
                error={!props.estadoFormulario.validadeCampos.numeroBanco}
                maxLength="3"
                label="Banco"
                onChange={e => props.handleChange(e, 'numeroBanco')}
                onBlur={e => props.handleBlur(e, 'numeroBanco')}
                value={props.estadoFormulario.regimeProprio.numeroBanco}
                dadosBancarios
                touched={props.estadoFormulario.touched || props.estadoFormulario.bancoTouched}
                required
              />
            }
          </Grid>
          <Grid cols="4 4 4 4">
            <Input
              disabled={(!props.auth.checkPermission(['analisar-negocio-sprev'])) || (props.estadoFormulario.regimeProprio.convenioComprev === 0)}
              value={props.estadoFormulario.nomeBanco}
              onChange={e => props.handleChange(e, 'nomeBanco')}
            />
          </Grid>
          <Grid cols="2 2 2 2">
            {props.estadoFormulario.regimeProprio.convenioComprev === 0 ?
              <Input
                disabled
                label="Agência"
                maxLength="4"
                value={props.estadoFormulario.regimeProprio.numeroAgencia}
                onChange={e => props.handleChange(e, 'numeroAgencia')}
                dadosBancarios
                touched={props.estadoFormulario.touched}
              />
              :
              <Input
                disabled={(!props.auth.checkPermission(['analisar-negocio-sprev']))}
                label="Agência"
                maxLength="4"
                value={props.estadoFormulario.regimeProprio.numeroAgencia}
                onChange={e => props.handleChange(e, 'numeroAgencia')}
                dadosBancarios
                touched={props.estadoFormulario.touched}
                required
              />
            }
          </Grid>
          <Grid cols="1 1 1 1">
            <Input disabled value="-" style={{ borderBottom: 'none', 'text-align': 'center' }} />
          </Grid>
          <Grid cols="1 1 1 1">
            <Input
              disabled={(!props.auth.checkPermission(['analisar-negocio-sprev'])) || (props.estadoFormulario.regimeProprio.convenioComprev === 0)}
              label="DV"
              maxLength="1"
              value={props.estadoFormulario.regimeProprio.dvAgencia}
              onChange={e => props.handleChange(e, 'dvAgencia')}
              onBlur={e => props.handleBlurDigitoVerificador(e, 'dvAgencia')}
              touched={props.estadoFormulario.touched}
            />
          </Grid>
          <Grid cols="2 2 2 2">
            {props.estadoFormulario.regimeProprio.convenioComprev === 0 ?
              <Input
                disabled
                error={!props.estadoFormulario.validadeCampos.numeroContaCorrente}
                label="Conta Corrente"
                maxLength="12"
                value={props.estadoFormulario.regimeProprio.numeroContaCorrente}
                onChange={e => props.handleChange(e, 'numeroContaCorrente')}
                dadosBancarios
                touched={props.estadoFormulario.touched}
              />
              :
              <Input
                disabled={(!props.auth.checkPermission(['analisar-negocio-sprev']))}
                error={!props.estadoFormulario.validadeCampos.numeroContaCorrente}
                label="Conta Corrente"
                maxLength="12"
                value={props.estadoFormulario.regimeProprio.numeroContaCorrente}
                onChange={e => props.handleChange(e, 'numeroContaCorrente')}
                dadosBancarios
                touched={props.estadoFormulario.touched}
                required
              />
            }
          </Grid>
          <Grid cols="1 1 1 1">
            <Input disabled value="-" style={{ borderBottom: 'none', 'text-align': 'center' }} />
          </Grid>
          <Grid cols="1 1 1 1">
            <Input
              disabled={(!props.auth.checkPermission(['analisar-negocio-sprev'])) || (props.estadoFormulario.regimeProprio.convenioComprev === 0)}
              maxlength="1"
              label="DV"
              value={props.estadoFormulario.regimeProprio.dvContaCorrente}
              onChange={e => props.handleChange(e, 'dvContaCorrente')}
              onBlur={e => props.handleBlurDigitoVerificador(e, 'dvContaCorrente')}
              touched={props.estadoFormulario.touched}
            />
          </Grid>
        </div>
        <div className="row">
          <Grid cols="5 5 5 5">
            {props.estadoFormulario.regimeProprio.inOrgaoUniao !== 1 &&
            props.estadoFormulario.regimeProprio.convenioComprev === 0 ?
              <Input
                disabled={(!props.auth.checkPermission(['analisar-negocio-sprev']))}
                error={!props.estadoFormulario.validadeCampos.idUOInssConvenio}
                label="UO INSS"
                onChange={e => props.handleChange(e, 'idUOInssConvenio')}
                onBlur={e => props.handleBlurIdUOInssConvenio(e, 'idUOInssConvenio')}
                value={props.estadoFormulario.regimeProprio.idUOInssConvenio}
                dadosBancarios
                maxlength="11"
                touched={props.estadoFormulario.touched || props.estadoFormulario.idUOInssConvenio}
              />
              :
              <Input
                disabled={(!props.auth.checkPermission(['analisar-negocio-sprev']))}
                error={!props.estadoFormulario.validadeCampos.idUOInssConvenio}
                label="UO INSS"
                onChange={e => props.handleChange(e, 'idUOInssConvenio')}
                onBlur={e => props.handleBlurIdUOInssConvenio(e, 'idUOInssConvenio')}
                value={props.estadoFormulario.regimeProprio.idUOInssConvenio}
                dadosBancarios
                maxlength="11"
                touched={props.estadoFormulario.touched || props.estadoFormulario.idUOInssConvenio}
                required
              />
            }
          </Grid>
          <Grid cols="7 7 7 7">
            <Input
              disabled={(!props.auth.checkPermission(['analisar-negocio-sprev']))}
              value={props.estadoFormulario.nomeUOInssConvenio}
              onChange={e => props.handleChange(e, 'nomeUOInssConvenio')}
            />
          </Grid>
        </div>
      </DataGrid>
      {(props.estadoFormulario.regimeProprio.inOrgaoUniao === 1) &&
      (props.estadoFormulario.situacao === constantes.orgaoAtivoCentralizado ||
      props.estadoFormulario.situacao === constantes.orgaoExtinto) ?
        <DataGrid
          title={props.estadoFormulario.situacao === constantes.orgaoExtinto ? 'Orgão Sucessor' : 'Orgão Controlador'}
          icon="ico-doc-book"
        >
          <div className="row">
            <Grid cols="8 8 8 8">
              <a
                className="row"
                href="#"
                // eslint-disable-next-line
                onClick={() => props.buscaParticipanteRpps(props.estadoFormulario.orgaoCentralizador.codigo)}
              >
                {`${props.estadoFormulario.orgaoCentralizador.codigo} -
                ${props.estadoFormulario.orgaoCentralizador.nome} -
                ${props.estadoFormulario.orgaoCentralizador.sigla}`}
              </a>
            </Grid>
          </div>
        </DataGrid>
      : ''}
      {(props.estadoFormulario.situacao === constantes.orgaoCentralizador) ||
      (props.estadoFormulario.situacao === constantes.orgaoAtivo) ?
        orgaosCentralizados
      : ''}
      <DataGrid title="Dados do Regime Próprio Vigente" icon="ico-user" >
        <div className="row">
          <Grid cols="12 12 12 12">
            <Input
              disabled={(!props.auth.checkPermission(['analisar-negocio-sprev']))}
              label="CNPJ do RPPS"
              mask={Masks.cnpj}
              showMask
              value={props.estadoFormulario.regimeProprio.cnpj}
              onChange={e => props.handleChange(e, 'cnpj')}
            />
          </Grid>
          <Grid cols="12 12 12 12">
            <Input
              disabled={(!props.auth.checkPermission(['analisar-negocio-sprev']))}
              label="Nome"
              maxLength="100"
              value={props.estadoFormulario.regimeProprio.nomeRpps}
              onChange={e => props.handleChange(e, 'nomeRpps')}
            />
          </Grid>
        </div>
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              disabled={(!props.auth.checkPermission(['analisar-negocio-sprev']))}
              maxLength="20"
              label="Sigla"
              value={props.estadoFormulario.regimeProprio.sigla}
              onChange={e => props.handleChange(e, 'sigla')}
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <Input
              disabled={(!props.auth.checkPermission(['analisar-negocio-sprev']))}
              label="Telefone"
              onChange={(e) => {
                // console.log(e);
                const cleanPhone = { value: e.value.replace(/[^\d \-()]/g, ''), isValid: true };
                props.handleChange(cleanPhone, 'telefone');
              }}
              maxLength="14"
              value={props.estadoFormulario.regimeProprio.telefone}
            />
          </Grid>
        </div>
        <div className="row">
          <Grid cols="4 4 4 4 ">
            <Input
              disabled={(!props.auth.checkPermission(['analisar-negocio-sprev']))}
              label="CEP"
              value={props.estadoFormulario.regimeProprio.cep}
              mask={Masks.cep}
              integer
              showMask
              onChange={e => props.handleChange(e, 'cep')}
            />
          </Grid>
          <Grid cols="8 8 8 8">
            <Input
              disabled={(!props.auth.checkPermission(['analisar-negocio-sprev']))}
              label="Endereço"
              value={props.estadoFormulario.regimeProprio.endereco}
              onChange={e => props.handleChange(e, 'endereco')}
            />
          </Grid>
        </div>
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              disabled={(!props.auth.checkPermission(['analisar-negocio-sprev']))}
              label="Bairro"
              value={props.estadoFormulario.regimeProprio.bairro}
              onChange={e => props.handleChange(e, 'bairro')}
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <Input
              disabled={(!props.auth.checkPermission(['analisar-negocio-sprev']))}
              label="Codigo do município"
              integer
              maxlength="5"
              value={props.estadoFormulario.regimeProprio.municipio}
              onChange={e => props.handleChange(e, 'municipio')}
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <Input
              disabled={(!props.auth.checkPermission(['analisar-negocio-sprev']))}
              label="UF"
              value={props.estadoFormulario.regimeProprio.ufRpps}
              onChange={e => props.handleChange(e, 'ufRpps')}
            />
          </Grid>
        </div>
      </DataGrid>
      {periodosVigencia}
    </React.Fragment>
  );
};

DadosRegimeProprio.propTypes = {
  acao: PropTypes.string.isRequired,
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleBlurDigitoVerificador: PropTypes.func.isRequired,
  handleBlurIdUOInssConvenio: PropTypes.func.isRequired,
  handleChangeAptoConvenio: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      protocolo: PropTypes.string,
      acao: PropTypes.string,
    }),
  }),
  periodosVigencia: PropTypes.arrayOf(PropTypes.shape({
    cnpj: PropTypes.string,
    dataCriacaoRpps: PropTypes.string,
    dataEncerramentoRpps: PropTypes.string,
  })),
  orgaosCentralizados: PropTypes.arrayOf(PropTypes.shape({
    codigo: PropTypes.string,
    nome: PropTypes.string,
  })),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  buscaParticipanteRpps: PropTypes.func.isRequired,
  // handleSuccessBuscaDadosParticipanteRpps: PropTypes.func.isRequired,
  // handleErrorBusca: PropTypes.func.isRequired,
};

DadosRegimeProprio.defaultProps = {
  match: null,
  periodosVigencia: [],
  orgaosCentralizados: [],
};

export default DadosRegimeProprio;



// WEBPACK FOOTER //
// ./src/pages/cadastros/EntesFederativos/Rpps/DadosRegimeProprio.jsx